// src/router/index.js
import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "@/views/HomePage.vue";
import NotFound from "@/views/NotFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    meta: {
      showHeader: false,
    },
  },
  // 您未来可以添加更多路由
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('@/views/AboutPage.vue')
  // }
];

const router = new VueRouter({
  mode: "history", // 推荐使用 history 模式，URL更美观
  base: process.env.BASE_URL,
  routes,
});

export default router;
